module.exports = __webpack_public_path__ + "static/media/aws.00996210.svg";